import * as React from 'react';
import {TextField, css, view} from '@sail/ui';

export const Size = () => (
  <view.div
    uses={[
      css({
        '& > *': {
          padding: css.value('8px 0'),
        },
      }),
    ]}
  >
    <TextField label="Small" size="small" />
    <TextField label="Medium" size="medium" />
    <TextField label="Large" size="large" />
  </view.div>
);
